/**
 *
 * @component 用户中心/数据看板/项目满意度卡片
 *
 **/
import { useHistory } from 'react-router-dom';
import { Empty } from 'antd';
import BaseCard from '@/components/UserCenter/BaseCard';
import ECharts from '&/components/BaseECharts/index';
import { Select } from '&/components/AntdEncapsulation';
import { getItemData } from '@/api/personCenter/dataBoard';
import { barOption } from './constants';
import './SatisfactionStatistics.scss';

function SatisfactionStatistics(props) {
    const {
        defaultValue,
        baseParams = {},
        managerOpts,
        dayOpts,
        isAdmin = false,
        userId = null,
    } = props;

    const [params, setParams] = useState({
        div: 3,
        managerId: userId,
        days: 30,
    });
    const [data, setData] = useState([]);

    const xAxis = [],
        build = [],
        manager = [],
        design = [];

    let count = 0;

    for (const item of data) {
        xAxis.push(item.name);
        const { number } = item;
        build.push(number.build);
        manager.push(number.manager);
        design.push(number.design);
        count += number.build;
        count += number.manager;
        count += number.design;
    }

    const options = {
        ...barOption,
        color: ['#71E4B7', '#5781EE', '#EFB353'],
        xAxis: [
            {
                type: 'category',
                axisTick: { show: false },
                data: xAxis,
            },
        ],
        series: [
            {
                name: '设计阶段',
                type: 'bar',
                barWidth: 12,
                label: {
                    show: false,
                },
                // emphasis: {
                //     focus: 'series',
                // },
                data: design,
            },
            {
                name: '施工阶段',
                type: 'bar',
                barGap: '25%',
                barWidth: 12,
                label: {
                    show: false,
                },
                // emphasis: {
                //     focus: 'series',
                // },
                data: build,
            },
            {
                name: '项目经理',
                type: 'bar',
                barGap: '25%',
                barWidth: 12,
                label: {
                    show: false,
                },
                // emphasis: {
                //     focus: 'series',
                // },
                data: manager,
            },
        ],
    };

    const canInit = !params.managerId && params.days === 30;

    useEffect(() => {
        canInit && setData(defaultValue || []);
    }, [defaultValue]);

    useEffect(() => {
        !canInit && reloadData();
    }, [baseParams.entId]);

    const first = useRef(true);
    useEffect(() => {
        !first.current && reloadData();
        first.current = false;
    }, [params]);

    const onChange = (val, key) => {
        setParams(prev => {
            const next = { ...prev };
            return {
                ...next,
                [key]: val,
            };
        });
    };

    function reloadData() {
        const PARAMS = { ...baseParams, ...params };
        console.log('reloadData');
        if (!baseParams.entId) {
            delete PARAMS.entId; // 让axios 自带entId
        }
        getItemData(PARAMS).then(({ data }) => {
            setData(data);
        });
    }

    const filterEl = (
        <>
            {managerOpts && (
                <Select
                    onChange={e => onChange(e, 'managerId')}
                    className="manager-select"
                    showSearch
                    filterOption={(input, option) =>
                        (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                    options={managerOpts}
                    value={params.managerId}></Select>
            )}
            <Select
                value={params.days}
                onChange={e => onChange(e, 'days')}
                options={dayOpts}></Select>
        </>
    );

    const HISTORY = useHistory();
    const targetList = () => {
        const urlParam = new URLSearchParams('');
        if (!isAdmin) {
            urlParam.append('manager', userId);
        } else if (params.managerId) {
            urlParam.append('manager', params.managerId);
        }
        urlParam.append('days', params.days);
        const path = isAdmin
            ? '/user-center/administrator/satisfaction-list?' +
              urlParam.toString()
            : '/user-center/manager/satisfaction-list?' + urlParam.toString();
        HISTORY.push(path);
    };

    return (
        <BaseCard
            className="satisfaction-statistics"
            title={intl.get('dataBoard.projectSatisfactionStatistics')}
            headerExtra={filterEl}>
            {count === 0 ? (
                <Empty
                    image={
                        require('&/assets/img/userCenter/emptyydata-object.png')
                            .default
                    }
                    imageStyle={{
                        height: 160,
                    }}
                    description={
                        <div className="hint-message">暂无数据</div>
                    }></Empty>
            ) : (
                <div onClick={targetList}>
                    <ECharts height="19.75rem" option={options}></ECharts>
                </div>
            )}
        </BaseCard>
    );
}

export default SatisfactionStatistics;
